import { render, staticRenderFns } from "./BookingFileListItem.vue?vue&type=template&id=71d98994"
import script from "./BookingFileListItem.vue?vue&type=script&lang=js"
export * from "./BookingFileListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports